import resolvePath from './resolvePath';
import type { Path } from './types';

export default (path: Path) => {
    const pathResolved = resolvePath(path);
    window.open(pathResolved, '_blank', 'noopener,noreferrer');
};
